export function waitForElement(selector: string, timeoutInterval: number = 5000) {
  return new Promise<Element | false>((resolve) => {
    // cheap early escape
    let element = document.querySelector(selector)
    if (element) {
      resolve(element)
      return
    }

    const timeout = setTimeout(() => { resolve(false) }, timeoutInterval)

    const observer = new MutationObserver(() => {
      element = document.querySelector(selector)
      if (!element) {
        return
      }

      clearTimeout(timeout)
      resolve(element)
      observer.disconnect()
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    // check one last time in case it appeared before observer was set up
    element = document.querySelector(selector)
    if (element) {
      clearTimeout(timeout)
      resolve(element)
      observer.disconnect()
    }
  })
}
